<!--
 * @Description: 忘记密码
 * @Date: 2019-12-27 11:34:04
 * @LastEditTime : 2020-01-09 18:08:40
 -->
<template>
  <div id="forgetPsd">
    <div class="content-wrap">
      <h3 class="title">
        找回密码
      </h3>
      <el-form
        ref="form"
        :model="form"
        status-icon
        :rules="rules"
        label-width="80px"
        autocomplete="off"
      >
        <el-form-item prop="account" label="邮箱/账号">
          <el-input v-model="form.account" type="text" placeholder="请输入邮箱/账号" />
        </el-form-item>
        <el-form-item label="验证码" prop="code" class="code">
          <el-input
            v-model="form.code"
            type="text"
            placeholder="请输入验证码"
          />
          <el-button
            :disabled="code.disabled"
            @click="handleGetCode"
          >
            {{ code.name }}
          </el-button>
        </el-form-item>
        <el-form-item prop="newPwd" label="新密码">
          <el-input
            v-model="form.newPwd"
            type="password"
            placeholder="请输入新密码"
            autocomplete="off"
            auto-complete="new-password"
          />
        </el-form-item>
        <el-form-item prop="checkNewPwd" label="确认密码">
          <el-input
            v-model.trim="form.checkNewPwd"
            type="password"
            placeholder="请再输入一次新密码"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            class="submit"
            type="primary"
            :loading="submitLoading"
            @click="handleSubmit('form')"
          >
            确 定
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <p class="tip">
      说明：请输入绑定的邮箱或者登录账号，验证码会发送到企业用户绑定的邮箱。
    </p>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { validatecode, validateNewPsd, validateReNewpsd } from '@/utils/validator'

export default {
  components: {},
  data() {
    const validateAccount = (rule, value, callback) => {
      if (value === '') {
        this.code.disabled = true
        callback(new Error('请输入邮箱/账号'))
      } else if (
        /^1(2|3|4|5|6|7|8|9)\d{9}$/.test(value) ||
        (value.indexOf('@') > -1 && value.length >= 4 && value.length <= 40) ||
        /^[a-zA-Z0-9_-]{6,18}$/.test(value)
      ) {
        this.code.disabled = false
        callback();
      } else {
        this.code.disabled = true
        callback(new Error('账号格式不正确'));
      }
    }
    return {
      form: {
        account: '',
        code: '',
        newPwd: '',
        checkNewPwd: ''
      },
      rules: {
        account: [{ validator: validateAccount, trigger: 'change' }],
        code: [{ validator: validatecode, trigger: 'blur' }],
        newPwd: [{ validator: validateNewPsd, trigger: 'blur' }],
        checkNewPwd: [{ validator: (rule, value, callback) => validateReNewpsd(rule, value, callback, this.form.newPwd), trigger: 'blur' }]
      },
      code: {
        disabled: true,
        name: '获取验证码',
        timer: null,
        second: 60
      }
    };
  },
  computed: {
    ...mapState({
      submitLoading: state => state.user.submitLoading
    })
  },
  watch: {

  },
  mounted() {},
  methods: {
    ...mapActions({
      getCode: 'user/getCode',
      resetPsd: 'user/resetPsd'
    }),
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.resetPsd(this.form).then(res => {
            this.$message({
              type: 'success',
              message: '密码找回成功',
              center: true
            })
            this.replaceTo('/login')
          })
        }
      });
    },
    // 获取验证码
    handleGetCode() {
      this.getCode({ account: this.form.account }).then(res => {
        if (res.status === 0) {
          this.$message({
            type: 'success',
            message: '已经向您发送重置密码邮件，有效期10分钟',
            center: true
          })
        }
        this.code.timer = setInterval(() => {
          this.code.disabled = true
          this.code.second = this.code.second - 1
          this.code.name = `${this.code.second}秒后重发`
          if (this.code.second === 0) {
            clearInterval(this.code.timer)
            this.$refs.form.validateField('account')
            this.code.name = '获取验证码'
            this.code.second = 60
          }
        }, 1000);
      })
    }
  }
};
</script>
<style lang="scss">
#forgetPsd {
  .content-wrap {
    width: 400px;
    margin: 0 auto;
    padding-top: 50px;
    transform: translateX(-40px);
    .title {
      padding: 40px 0 40px 80px;
      text-align: center;
      font-size: 20px;
      color: #666;
    }
    .code {
      .el-form-item__content {
        display: flex;
        align-items: center;
        .el-button {
          margin-left: 15px;
        }
      }
    }
    .submit {
      width: 100%;
    }
  }
  .tip {
    padding: 6px 15px;
    text-align: center;
    font-size: 14px;
    color: #999;
  }
}
</style>
